// Shared role/permission helpers for the Project Management task module.
//
// Role model (see hr_staff_basic_infos):
//   - user_type === "admin"      -> full access (the seeded "Super Admin" account)
//   - department_head === 1      -> department head, also full access
//   - everyone else              -> normal member (restricted)
//
// A "privileged" user (admin or head) can view/edit/copy/delete every task and
// see the calendars. A normal member sees mainly their own tasks and can only
// change the status of a task they are assigned to.

export const isPrivilegedUser = (user) =>
  !!user &&
  (user.user_type === "admin" || Number(user.department_head) === 1);

// True when the given user is one of the developers assigned to the task.
export const isOwnTask = (task, userId) =>
  Array.isArray(task?.developers) &&
  task.developers.some((dev) => dev.id === userId);
